import ProgressBar from '../ProgressBar/ProgressBar';
import classes from './Stepper.module.scss';

const Stepper = ({ baseColor = 'blue2', steps, step, className, selectClick, ...props }) => {
  const containerClasses = [classes.container];
  if (className) {
    containerClasses.push(className);
  }

  return (
    <div>
      <div className={classes.containt}>
        <div className={classes.progress}>
          <ProgressBar className={classes.bar} max={steps.length} value={step + 1} />
        </div>
      </div>
      <div className={containerClasses.join(' ')} {...props}>
        {steps.map(({ label, key }, index) => {
          const stepClasses = [classes[`number-border-${baseColor}`], classes.number];
          let textClasses = [classes[`text-color-${baseColor}`]];
          const textNumber = [classes[`text-color-${baseColor}`]];
          if (index === step) {
            stepClasses.push(classes.active);
            textClasses.push(classes[`text-color-active-${baseColor}`]);
            textNumber.push(classes['text-number-active']);
          } else if (step > index) {
            stepClasses.push(classes['finish']);
            textNumber.push(classes['finish-label']);
            textClasses.push('pointer');
            textClasses.push(classes[`text-color-active-${baseColor}`]);
          }

          return (
            <div key={index} className={classes.step}>
              <div name={key} className={`${stepClasses.join(' ')}`}>
                <span name={key} className={`${textNumber.join(' ')} semibold-16`}>
                  {step <= index ? index + 1 : null}
                </span>
              </div>
              <span onClick={step > index ? () => selectClick(index) : () => {}} className={`semibold-16 ${textClasses.join(' ')}`}>
                {label}
              </span>
              {steps.length !== index + 1 && (
                <div className={classes.separator}>
                  <span className={`semibold-16 `}>......</span>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Stepper;

/*  <div className={classes.progress}>
          <div
            className={`${classes.circle}`}
            style={{ backgroundImage: `conic-gradient(#2f97c1 ${((step + 1) * 100) / steps.length}%, #e5e7ec 0)` }}
          >
            <div className={classes.inner}>
              <span className='bold-18'>{step + 1}</span>
              <span className={`${classes.color} bold-18`}>/{steps.length}</span>
            </div>
          </div>
          <div className={classes.info}>
            <span className={`${classes.color} medium-14`}>Paso {step + 1}</span>
            <span className='semibold-18'>{steps[step].label}</span>
            {steps[step + 1] && <span className={`${classes.color} medium-14`}>Paso siguiente: {steps[step + 1].label}</span>}
          </div>
        </div> */
